import { yup } from 'src/common/infra/validations/yup';

export const loginSchema = yup.object().shape({
    password: yup.string().required('field_validations.required'),
});
